import { ReactNode } from "react";
import { Button, Plus } from '@core/ui';

interface AddItemButtonProps {
    children?: ReactNode;
    onClick: () => void;
}

export const AddItemButton = ({ children, onClick }: AddItemButtonProps) => {

    return (
        <Button variant="primary-outline" iconbtn classNames="ms-3" onClick={onClick}>
            <span className="sr-only">{ children }</span>
            <Plus classNames="size-6 stroke-current" />
        </Button>
    );
};
